export const accountEmail = {
  type: "string",
  format: "email",
  minLength: 1,
  maxLength: 255
};
